import React from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import routes from "../../../routes.js";
import {MdNavigateBefore, MdOutlineNavigateNext} from "react-icons/md";
import {useSelector} from "react-redux";
import NLPLogs from "../default/components/NLPLogsDatatable";
import SearchQueryDetails from "../../details/NLPDetails";

export default function NLPage(props) {
    const {...rest} = props;
    const location = useLocation();
    let {id} = useParams();
    const [open, setOpen] = React.useState(true);
    const [currentRoute, setCurrentRoute] = React.useState("All Chats");

    let AllNLP = useSelector(state => state.AllNLP);
    const navigate = useNavigate();

    React.useEffect(() => {
        window.addEventListener("resize", () =>
            window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
        );
    }, [])

    ;
    React.useEffect(() => {
        getActiveRoute(routes);
    }, [location.pathname]);


    const getActiveRoute = (routes) => {
        let activeRoute = "Main Dashboard";
        for (let i = 0; i < routes.length; i++) {
            if (
                window.location.href.indexOf(
                    routes[i].layout + "/" + routes[i].path
                ) !== -1
            ) {
                setCurrentRoute(routes[i].name);
            }
        }
        return activeRoute;
    };


    const getActiveNavbar = (routes) => {
        let activeNavbar = false;
        for (let i = 0; i < routes.length; i++) {
            if (
                window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
            ) {
                return routes[i].secondary;
            }
        }
        return activeNavbar;
    };


    const navigateNext = () => {
        console.log("Navigate Next", AllNLP);
        const currentIndex = AllNLP.findIndex(chat => chat.id === id);

        if (currentIndex !== -1 && currentIndex < AllNLP.length - 1) {
            const nextChat = AllNLP[currentIndex + 1];
            navigate(`/nlp/${nextChat.id}`);
        } else {
            alert("No next chat available.");
        }
    };

    const navigateBack = () => {
        const currentIndex = AllNLP.findIndex(chat => chat.id === id);

        if (currentIndex > 0) {
            const previousChat = AllNLP[currentIndex - 1];
            navigate(`/nlp/${previousChat.id}`);
        } else {
            alert("No previous chat available.");
        }
    };

    return (
        <div>
            {id && <div className="flex flex-row-reverse border-0 justify-between">
                <MdOutlineNavigateNext onClick={() => navigateNext()} className={"h-7 w-7 cursor-pointer"}/>
                <MdNavigateBefore onClick={() => navigateBack()} className={"h-7 w-7 cursor-pointer"}/>
            </div>
            }


            <div className="pt-5s mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
                {id ? <SearchQueryDetails id={id}/> : <NLPLogs tableData={AllNLP}/>}
            </div>

        </div>

    );
}
